import { render, staticRenderFns } from "./AccountRecharge.vue?vue&type=template&id=bcfdf46a&scoped=true&"
import script from "./AccountRecharge.vue?vue&type=script&lang=js&"
export * from "./AccountRecharge.vue?vue&type=script&lang=js&"
import style0 from "./AccountRecharge.vue?vue&type=style&index=0&id=bcfdf46a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcfdf46a",
  null
  
)

export default component.exports